import ThemesContent from "../components/others/themesScreen/ThemesContent";
import ThemesLayout from "../components/layouts/themesScreen/ThemesLayout";
import ThemesContentLayout from "../components/layouts/themesScreen/ThemesContentLayout";
import SystemScreenTopBar from "../components/bars/SystemScreenTopBar";
import {useResizeListener} from "../listeners/SystemResizeListener";
import {useState} from "react";
import SystemAppDrawer from "../components/others/SystemAppDrawer";

export default function ThemesScreen() {
    // Referenced in index.js as a root screen, used to display
    // explanations about official program and Themes

    // PROPERTIES
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return (
        <div className={"animate-appearSlow overflow-auto w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center"}>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={null}
                                openDrawer={openDrawer} />
            <ThemesLayout>
                <ThemesContentLayout>
                    <div className={"w-full flex justify-start"}>
                        <span className={"text-[24px] text-white font-bold"}>
                            {"Le programme scolaire"}
                        </span>
                    </div>
                    <ThemesContent />
                </ThemesContentLayout>
            </ThemesLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }
}